import type { ReactNode } from 'react';
import { Header } from './Header';

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * Main application layout with horizontal header navigation
 * Used for authenticated pages
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      {/* Header with horizontal navigation */}
      <Header />

      {/* Page content - full width */}
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  );
}
